import React, { Component } from 'react';
import {connect} from "react-redux";
/*import { Bar, Line } from 'react-chartjs-2';*/
/*import {Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';*/ // minimize
import classnames from 'classnames'; // minimize

import PermissionProperties from '../../../config/permission.js'
import RenderHelper from '../../../asset/tracking/helper/render.js'
import RequestProps from '../../../asset/asset/helper/request_props.js'
import TrackingPresenter from '../../../asset/tracking/presenter.js'
import TrackingRequestProps from '../../../asset/tracking/helper/request_props.js'
import TimelineRow from '../../../asset/home/helper/row.js'
/*import iconMaping from '../../../utils/IconMaping.js';*/
import Chart from '../../../home/helper/component/Chart/Chart.js';
import AssetList from '../../../home/helper/component/MyAsset/AssetList.js'
import windowStop from 'utils/windowStop.js'

class HomeScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0, // 768 is mobile
      dropdownOpen:false,
      rowElement  : '',
      isLoading   : true,
      assetPanel  : false,
      Tracking:{
        query : this.props.match.params.Alias,
      },
    }

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.closePanel           = this.closePanel.bind(this);
    this.OnReadSuccess    = this.OnReadSuccess.bind(this);
    this.OnReadFailed     = this.OnReadFailed.bind(this);
    this.NextTrackingPage = this.NextTrackingPage.bind(this);

    if (this.props.match.params.Filter === "asset") {
      TrackingPresenter.ReadAllTrackingByAsset(TrackingRequestProps.ReadProps("Read", this.OnReadSuccess,null,PermissionProperties.ASSET.TRACKING.READ,this.state.Tracking,this.props,"-ChekinTime",''))
    }else if (this.props.match.params.Filter === "location") {
      TrackingPresenter.ReadAllTrackingByFilter(TrackingRequestProps.ReadProps("Read", this.OnReadSuccess,null,PermissionProperties.ASSET.TRACKING.READ,this.state.Tracking,this.props,"-ChekinTime",'',this))
    }else if (this.props.match.params.Filter === "user") {
      TrackingPresenter.ReadAllTrackingByFilter(TrackingRequestProps.ReadProps("Read", this.OnReadSuccess,null,PermissionProperties.ASSET.TRACKING.READ,this.state.Tracking,this.props,"-ChekinTime",'',this))
    }else { // show all activities
      TrackingPresenter.ReadAllTracking(TrackingRequestProps.ReadProps("Read", this.OnReadSuccess,this.OnReadFailed,PermissionProperties.ASSET.TRACKING.READ,this.state.Tracking,this.props,"-ChekinTime",''))
    }
  }

  closePanel() {
    this.setState({
      assetPanel: false
    });
  }

  PreviousTrackingPage(self,props){
    if(self.props.match.params.Filter === "asset"){
      TrackingPresenter.ReadAllTrackingByAsset(props)
    }else if(self.props.match.params.Filter === "location"){
      TrackingPresenter.ReadAllTrackingByFilter(props)
    }else if(self.props.match.params.Filter === "user"){
      TrackingPresenter.ReadAllTrackingByFilter(props)
    }else{
      TrackingPresenter.ReadAllTracking(props)
    }
  }
  NextTrackingPage(self,props){
    if(self.props.match.params.Filter === "asset"){
      TrackingPresenter.ReadAllTrackingByAsset(props)
    }else if(self.props.match.params.Filter === "location"){
      TrackingPresenter.ReadAllTrackingByFilter(props)
    }else if(self.props.match.params.Filter === "user"){
      TrackingPresenter.ReadAllTrackingByFilter(props)
    }else{
      TrackingPresenter.ReadAllTracking(props)
      this.setState({isLoading: true})
    }
  }

  OnReadSuccess(params, response) {
    if (params.action === "Read") {
      this.setState({
        rowElement : response.data.results,
        isLoading  : false
      })

    } else {
      // next load
      let newData = this.state.rowElement.concat(response.data.results);
      this.setState({
        rowElement : newData,
        isLoading  : false
      })

    }
  }

  OnReadFailed(response) {

  }

  setSummaryTab(summaryTab){
    this.setState({ 
      summaryTab,
      assetPanel: true
    })
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    windowStop()
  } 

  updateWindowDimensions() {
    this.setState({ 
      width: window.innerWidth
    });
  }

  RenderTimeline(){
    if(this.props.TrackingReducer.rs === null){
      return
    }

    if(this.props.TrackingReducer.rs.length === 0){
      return(
        <div className="card-block align-center NoDataContainer">
          <div>
            <span><i className="fa-5x icon-notebook"></i></span><br/>
            <span><b>No Data Found</b></span><br/>
          </div>
        </div>
      )
    }

    var jsx = [];
    for(var i = 0 ; i < this.state.rowElement.length; i++){
      jsx.push(
        <TimelineRow
          key         ={i} 
          data        ={this.state.rowElement[i]} 
          UserReducer = {this.props.UserReducer}
          width       ={this.state.width}
        />
      )
    }
    return jsx;
  }

  render() {
    const {width} = this.state

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <Chart 
              SetSummaryTab ={this.setSummaryTab.bind(this)} 
              UserReducer   ={this.props.UserReducer} 
              tenant        ={true}
            />
          </div>
        </div>
        <div className={classnames("row panel-asset-admin", {'show' : this.state.assetPanel})}>
          <div className="btn-close-box-center" onClick={this.closePanel}><span className="icon-arrow-up"></span></div>
          <div className="col-md-12">
            <div className="card">
              <div className="card-block">
              <AssetList {...this.props}
                SummaryTab  ={this.state.summaryTab} 
                UserReducer ={this.props.UserReducer}
                onRef       ={ref => (this.assetList = ref)}
                isAdmin     = {true}
              />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <i className="fa fa-align-justify"/> Activities
              </div>

              <div className={classnames({'timeline-mobile' : width <= 768 }, {'timeline' : width >= 768 })}>
                {this.RenderTimeline()}
              </div>

              <div className="m-top-15 mb-5">
                <div className="col-md-12 text-center">
                  {
                    RenderHelper.RenderLoadMore (
                      this, 
                      this.props.Reducer, 
                      this.NextTrackingPage,
                      RequestProps.ReadProps(
                        "Next", 
                        this.OnReadSuccess,
                        this.OnReadFailed,
                        PermissionProperties.ASSET.TRACKING.READ,
                        this.state,
                        this.props,
                        '',
                        this,
                      )
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
      Reducer: state.TrackingReducer,
      UserReducer: state.UserReducer,
      RequestReducer : state.RequestReducer,
      TrackingReducer : state.TrackingReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RunRedux: (data) => {
            dispatch(data);
        },
    };
};

// export default AssetScreen;
export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/home_admin.js